import React, { Fragment } from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import FormControl from '@material-ui/core/FormControl';

import TextField from '@material-ui/core/TextField';

import Label from './Label';
import BetweenLabel from './BetweenLabel';

import { AppState } from '../../../appredux';

import { connect } from 'react-redux';

//PM 2021-10-27
// touched: boolean,
// error: string,
export interface FormikTextFieldProps {
    key: string | number,
    name: string,
    value: string | number,
    dirtyBackground?: string,
    completed?: boolean,
    type?: string,
    formControlStyle?: React.CSSProperties,
    label?: string,
    betweenLabel?: string,
    labelSecondary?: boolean,
    labelBold?: boolean,
    labelBlock?: boolean,
    labelStyle?: React.CSSProperties,
    labelClasses?: string,
    placeholder?: string,
    style?: React.CSSProperties,
    inputStyle?: React.CSSProperties,
    className?: string,
    inputClasses?: string,
    required?: boolean,
    autoFocus?: boolean,
    startAdornment?: JSX.Element,
    onChange: (e: React.ChangeEvent<{ name?: string; value: any }>) => void,
    onClick: () => void,
    disabled?: boolean,
    touched: boolean,
    error: string,
    multiline?: boolean,
    rows?: number, 
}

interface FormikTextFieldState {
    selected: boolean
}

interface InputProps {
    classes?: { input: string },
    startAdornment?: JSX.Element,
    onChange?: (e: React.ChangeEvent<{ name?: string; value: any }>) => void
    onClick?: () => void
}

class FormikTextField extends React.Component<FormikTextFieldProps & WithStyles<typeof styles>, FormikTextFieldState> {

    constructor(props: FormikTextFieldProps & WithStyles<typeof styles>) {
        super(props);
        this.state = { selected: false };
    }

    componentDidUpdate(prevProps: FormikTextFieldProps & WithStyles<typeof styles>) {
        if (!this.state.selected && prevProps.value !== this.props.value)
            this.setState({ selected: true });
    }

    //PM 2021-10-27
    //zrezygnowanie z formik-mui
    field = () => {
        let InputProps: InputProps = {};

        if (this.props.inputClasses)
            InputProps = { ...InputProps, classes: { input: this.props.inputClasses } };

        if (this.props.startAdornment)
            InputProps = { ...InputProps, startAdornment: this.props.startAdornment };

        if (this.props.onChange)
            InputProps = { ...InputProps, onChange: this.props.onChange, };  
        
        if (this.props.onClick)
            InputProps = { ...InputProps, onClick: this.props.onClick, };

        return (
            <TextField
                type={this.props.type ? this.props.type : 'text'}
                name={this.props.name} className={this.props.className}
                style={this.props.style}
                variant="outlined"
                placeholder={this.props.placeholder || undefined}
                autoFocus={this.props.autoFocus}
                inputProps={{
                    style: ((this.state.selected || this.props.completed) && this.props.value) || this.props.disabled ?
                        {
                            ...this.props.inputStyle,
                            backgroundColor: this.props.dirtyBackground
                        }
                        : this.props.inputStyle
                }}
                InputProps={InputProps} disabled={this.props.disabled}
                value={this.props.value}
                error={this.props.touched && Boolean(this.props.error)}
                helperText={this.props.touched && this.props.error}
                multiline={this.props.multiline}
                rows={this.props.rows ? this.props.rows : 1}
            />
        )
    }

    render() {
        const classes = this.props.classes;

        return (
            <Fragment>
                <FormControl
                    variant="outlined" margin="normal" fullWidth
                    className={classes.formControl}
                    style={this.props.formControlStyle}
                >
                    {this.props.betweenLabel ?
                        <BetweenLabel
                            label={this.props.betweenLabel}
                            secondary={this.props.labelSecondary}
                        />
                        :
                        <Label
                            label={this.props.label}
                            secondary={this.props.labelSecondary}
                            bold={this.props.labelBold}
                            block={this.props.labelBlock}
                            style={this.props.labelStyle}
                            className={this.props.labelClasses}
                            required={this.props.required}
                        />
                    }
                    {this.field()}
                </FormControl>
            </Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    formControl: {
        display: "block",
        marginTop: "0px",
        //paddingBottom: "35px"
    },
});

const mapStateToProps = (state: AppState) => ({
    dirtyBackground: state.pageState.secondaryLight
});

export default connect(mapStateToProps)(withStyles(styles)(FormikTextField));